export const responseCountryMock = {
    data: [{
        "nome_pais": "Brasil",
        "codigo_ddi": "55",
        "sigla_pais_tres_caracteres": "BRA",
        "sigla_pais_dois_caracteres": "BR"
    },
    {
        "nome_pais": "Bahamas",
        "codigo_ddi": "1-242",
        "sigla_pais_tres_caracteres": "BHS",
        "sigla_pais_dois_caracteres": "BS"
    },
    ]
}